import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=a4297d9c"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"
import style0 from "./textarea.vue?vue&type=style&index=0&id=a4297d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports